import * as React from 'react'

import { EngagementContext } from 'modules/engagement/pages/RootPage'

export const useEngagementContext = () => {
  const context = React.useContext(EngagementContext)

  if (!context) {
    throw new Error('EngagementContext must be within its provider')
  }

  return context
}
